/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { hierarchyScopeSchema } from './hierarchyScopeSchema';
import { loopFinancialsSchema } from './loopFinancialsSchema';

export const loopFinancialsResponseSchema = z.object({
  get financials() {
    return loopFinancialsSchema.describe(
      "Financial summary rolled up from the loop's effective top-level items",
    );
  },
  get hierarchyScope() {
    return z.union([hierarchyScopeSchema, z.null()]).optional();
  },
  loopId: z.int().describe('Loop id'),
});
